export default class Utils {
	public static fieldRegex = {
		email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/,
		document: /^[A-Z0-9]*$/,
		// eslint-disable-next-line max-len
		name: /^[A-ZÀ-ÖØ-Ý][a-zÀ-ÖØ-öø-ÿ]*(?:['-][A-ZÀ-ÖØ-Ý][a-zÀ-ÖØ-öø-ÿ]*)*(?:\s[A-ZÀ-ÖØ-Ý][a-zÀ-ÖØ-öø-ÿ]*(?:['-][A-ZÀ-ÖØ-Ý][a-zÀ-ÖØ-öø-ÿ]*)*)*(?:\s[A-ZÀ-ÖØ-Ý]+)*$/,
	};

	public static validate = (field: string, value: string) => (
		Utils.fieldRegex[field as keyof typeof Utils.fieldRegex].test(value)
	);
}
